import { useState, useEffect, useId, type ReactNode } from "react";
import { TabsContext, type TabsContextType } from "./TabsContext";

interface TabsContainerProps<T extends string> {
  value?: T;
  defaultValue?: T;
  onChange?: (value: T) => void;
  children: ReactNode;
}

export function TabsContainer<T extends string>({
  value,
  defaultValue,
  onChange,
  children,
}: TabsContainerProps<T>) {
  const isControlled = value !== undefined;
  const [internalValue, setInternalValue] = useState<T>(defaultValue as T);

  useEffect(() => {
    if (isControlled && value !== internalValue) {
      setInternalValue(value as T);
    }
  }, [value, isControlled, internalValue]);

  const idPrefix = useId();

  const setActiveValue = (val: T) => {
    if (!isControlled) {
      setInternalValue(val);
    }
    onChange?.(val);
  };

  const ctxValue: TabsContextType = {
    activeValue: isControlled ? (value as string) : internalValue,
    setActiveValue: setActiveValue as (val: string) => void,
    idPrefix,
  };

  // t("cashier.saved_payment_account.new_spa_matched_spa_with_invalid_status")
  return (
    <TabsContext.Provider value={ctxValue}>{children}</TabsContext.Provider>
  );
}
